<template>
  <v-row wrap class="justify-center justify-md-start justify-sm-center">
      <v-col md12 xs10 class="mb-md-3 mb-lg-12 mb-xl-12 medium_header">
          <h2 class="text-md-center">{{medheader}}</h2>
      </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'MediumHeader',
  props: ["medheader"]
}
</script>

<style lang="scss" scoped>
  @import url('https://fonts.googleapis.com/css2?family=Fauna+One&display=swap');
  .medium_header {
    // color: #252323;
    color: #707070;
    font-family: 'Fauna One', serif;  
    font-size: 1.8rem;
  }
  @import '~vuetify/src/styles/settings/_variables.scss';
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .medium_header {
      font-size: 1rem;
    }
  }
</style>